'use client'

import React from 'react'
import classNames from 'classnames'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/ui/atoms/Select'

/**
 * Filter option type definition
 */
export type SortingOption = {
  label: string
  propertyName: string
  dir: 'asc' | 'desc'
}

/**
 * Props for the SortBy component
 */
type SortByProps = {
  /** Title displayed next to the sorting options */
  title: string
  /** Array of sorting options to display */
  sortingOptions: SortingOption[]
  /** Current sort value */
  currentSort?: string
  /** Callback when sort changes */
  onSortChange: (value: string) => void
  /** Whether data is currently loading */
  isLoading?: boolean
  /** Additional CSS classes */
  className?: string
}

/**
 * SortBy component displays a dropdown of sorting options
 */
export const SortBy: React.FC<SortByProps> = ({
  title,
  sortingOptions,
  currentSort = '',
  onSortChange,
  isLoading = false,
  className,
}) => {
  return (
    <div
      className={classNames(className, 'w-full md:w-auto flex flex-col items-start')}
      data-pending={isLoading}
    >
      <span className="text-text-faded text-label-XS-semibold mb-2">{title}</span>

      <Select onValueChange={onSortChange} value={currentSort} disabled={isLoading}>
        <SelectTrigger className="w-full md:w-auto">
          <SelectValue placeholder={'Sort by'} />
        </SelectTrigger>
        <SelectContent>
          {sortingOptions.map(({ label, propertyName, dir }) => {
            const optionValue = `${dir === 'desc' ? '-' : ''}${propertyName}`
            return (
              <SelectItem key={optionValue} value={optionValue}>
                {label}
              </SelectItem>
            )
          })}
        </SelectContent>
      </Select>
    </div>
  )
}
